import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    // {
    //   path: '*',
    //   redirect: '/'
    // },
    {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [{
        path: '/',
        redirect: '/home'
      },
      {
        path: '/home',
        name: 'home',
        component: resolve => require(['@/view/homePage'], resolve),
        meta: {
          title: '首页'
        }
      },
      {
        path: '/produce',
        name: 'Produce',
        component: resolve => require(['@/view/produce'], resolve),
        meta: {
          title: '产品中心 | Produce'
        },
      },
      {
        path: '/produce/:itemType',
        name: 'ProduceType',
        component: resolve => require(['@/view/produce/component/produceType'], resolve),
        meta: {
          title: '产品中心 | M.2 SATA'
        },
      },
      {
        path: '/produce/info/:item',
        name: 'ProduceInfo',
        component: resolve => require(['@/view/produce/component/info'], resolve),
        meta: {
          title: '产品中心 | M.2 SATA'
        },
      },

      {
        path: '/mark',
        name: 'Mark',
        component: resolve => require(['@/view/mark'], resolve),
        meta: {
          title: '市场与行业 | Mark'
        },
      },
      {
        path: '/mark/:item',
        name: 'IndustryPage',
        component: resolve => require(['@/view/mark/component/IndustryPage'], resolve),
        meta: {
          title: '八大板块'
        }
      },
      {
        path: '/mark/product/:item',
        name: 'ProductDisplay',
        component: resolve => require(['@/view/mark/component/ProductDisplay'], resolve),
        meta: {
          title: '产品展示'
        }
      },
      {
        path: '/aboutView',
        name: 'About',
        component: resolve => require(['@/view/about/aboutView'], resolve),
        meta: {
          title: '关于我们'
        },
      },
      {
        path: '/aboutView',
        name: 'AboutView',
        component: resolve => require(['@/view/about/aboutView'], resolve),
        meta: {
          title: '公司介绍'
        },
      },
      {
        path: '/myCaption',
        name: 'MyCaption',
        component: resolve => require(['@/view/about/myCaption'], resolve),
        meta: {
          title: '我的工厂'
        },
      },
      {
        path: '/contUs',
        name: 'ContUs',
        component: resolve => require(['@/view/about/contUs'], resolve),
        meta: {
          title: '联系我们'
        }
      },
      {
        path: '/newsView',
        name: 'NewsView',
        component: resolve => require(['@/view/about/newsView'], resolve),
        meta: {
          title: '新闻资讯'
        },
      },
      {
        path: '/newsView/:id',
        name: 'NewsDetail',
        component: resolve => require(['@/view/about/newsDetail'], resolve),
        meta: {
          title: '新闻详情'
        },
      },
      {
        path: '/salesSupport',
        name: 'SalesSupport',
        component: resolve => require(['@/view/salesSupport'], resolve),
        meta: {
          title: '销售与支持'
        },
      }
      ]
    }
  ],
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    };
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js